import React from 'react';
import { bool } from 'prop-types';

function EmptyState({ isMentor }) {
  return (
    <div className="arc-text-align-c empty-state-wrapper">
      <img src={`${window.staticPath}img/mentorship/new/no-connections.png`} alt="no connections found" width={184} />
      <p className="mt12 arc-H200 arc-color-gray9">Your connections will appear here.</p>
      <If condition={!isMentor}>
        <p className="arc-H200 arc-color-gray9">
          Start your mentorship journey with the
          {' '}
          <a href="/mentorship/mentors" className="arc-text-underline arc-H200">
            mentors tab
          </a>
          {' '}
          and find someone
          <br />
          who can help you reach your goals.
        </p>
      </If>
    </div>
  );
}

EmptyState.propTypes = {
  isMentor: bool.isRequired,
};

export default EmptyState;
